{
    "loading": "Cargando",
    "home": "Inicio",
    "about": "Acerca de",
    "profile": "Mi Perfil",
    "signIn": "Iniciar sesión",
    "signUp": "Registrarse"
}